import { socketHandler } from '@fiverr-private/futile';

export function subscribeToChannel(channel, callback) {
    socketHandler.on(channel, callback);

    return () => {
        socketHandler.off(channel, callback);
    };
}
